(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-spec-pills"] && !Shopify.designMode) return;
  try {
    function initializeProductSpecSlider(root = document) {
    root.querySelectorAll('.product-spec-pills-shell').forEach((slider) => {
      if (slider.dataset.sliderReady === 'true') return;

      const scroller = slider.querySelector('.product-spec-pills-viewport');
      const previousButton = slider.querySelector('.product-spec-pills__control--previous');
      const nextButton = slider.querySelector('.product-spec-pills__control--next');
      if (!scroller || !previousButton || !nextButton) return;

      slider.dataset.sliderReady = 'true';

      const updateButtons = () => {
        const maximumScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        previousButton.hidden = scroller.scrollLeft <= 2;
        nextButton.hidden = scroller.scrollLeft >= maximumScroll - 2;
      };

      const moveSlider = (direction) => {
        const distance = Math.max(140, Math.round(scroller.clientWidth * 0.72));
        scroller.scrollBy({ left: direction * distance, behavior: 'smooth' });
      };

      previousButton.addEventListener('click', () => moveSlider(-1));
      nextButton.addEventListener('click', () => moveSlider(1));
      scroller.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);

      let isMouseDragging = false;
      let activePointerId = null;
      let pointerStartX = 0;
      let startingScrollLeft = 0;

      const stopDragging = () => {
        if (!isMouseDragging) return;

        isMouseDragging = false;
        activePointerId = null;
        scroller.classList.remove('is-mouse-dragging');
        updateButtons();
      };

      scroller.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch' || event.button !== 0) return;
        if (scroller.scrollWidth <= scroller.clientWidth + 2) return;

        event.preventDefault();
        isMouseDragging = true;
        activePointerId = event.pointerId;
        pointerStartX = event.clientX;
        startingScrollLeft = scroller.scrollLeft;
        scroller.classList.add('is-mouse-dragging');
        scroller.setPointerCapture(event.pointerId);
      });

      scroller.addEventListener('pointermove', (event) => {
        if (!isMouseDragging || event.pointerId !== activePointerId) return;

        event.preventDefault();
        scroller.scrollLeft = startingScrollLeft - (event.clientX - pointerStartX);
      });

      scroller.addEventListener('pointerup', stopDragging);
      scroller.addEventListener('pointercancel', stopDragging);
      scroller.addEventListener('lostpointercapture', stopDragging);

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(updateButtons);
        resizeObserver.observe(scroller);
      }

      requestAnimationFrame(updateButtons);
      setTimeout(updateButtons, 250);
    });
  }

  initializeProductSpecSlider();
  document.addEventListener('shopify:section:load', (event) => {
    initializeProductSpecSlider(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
